import { SelectionListInfo } from "./vo/selection-list-info.model";
import { ReplacementListInfo} from "./vo/replacement-list-info.model";
import { TargetListInfo } from "./vo/target_list_info.model";
import { CodeListInfo } from "./vo/code_list_info.model";
import { GetCodeListResponse } from "src/app/commons/kymw02/api-services/get-code-list.service";

/**
 * 表紙特集掲載商品選定（バイヤー）の値を管理するクラス
 *
 * @export KYMW7001Model
 * @class KYMW7001Model
 */
export class KYMW7001Model {

  // 画面バインド用変数
  // 受注コード
  public orderCode: string = <string>"";
  // 企画回
  public catalogId: string = <string>"";
  // 媒体区分
  public mediumType: string = <string>"";
  // 特集コード
  public featureCode: string = <string>"";
  // 特集メモ
  public featureMemo: string = <string>"";
  // バイヤー選定依頼ID
  public buyerRequestId: string = <string>"";
  // 選定商品一覧.全選択チェックボックス
  public selectionListAll: boolean = <boolean>false;

  // 候補一覧
  public TargetListInfo: TargetListInfo[] = [];
  // 選定商品一覧
  public SelectionList: SelectionListInfo[] = [];
  // 差し替え対象一覧
  public ReplacementList: ReplacementListInfo[] = [];
  // 選定対象
  public SelectionTargetList: SelectionListInfo[] = [];

  // 特集一覧
  public FeatureList: CodeListInfo[] = [];
  // 媒体一覧
  public MediumList: CodeListInfo[] = [];
  // バイヤーコードリスト
  public BuyreCodeList: GetCodeListResponse = [];
  // 価格パターンリスト
  public PricePetternList: GetCodeListResponse = [];
}
